import { Component, Vue, Prop } from 'vue-property-decorator';
import LineItem from '@/services/line_item.ts';
import FulfillmentExternalRequest from '@/services/fulfillment_external_requests.ts';
import { chunk as _chunk } from 'lodash';

@Component({})
export default class RequestExternalFulfillment extends Vue {
  @Prop() query: any;
  lineItemService = new LineItem();
  fulfillmentExtalnalRequestService = new FulfillmentExternalRequest();
  lineItems: any[] = [];
  perPage = 50;
  currentPage = 1;
  totalData = 0;
  maxId = 0;
  queryAction: any = {};
  isLoading = false;
  isDone = false;
  successLineItemIds: number[] = [];
  maxPage: number = 0;

  public lineItemIds: number[] = [];
  public isLoadingComponent = false;

  async mounted() {
    this.isDone = false;
    this.queryAction = JSON.parse(JSON.stringify(this.query));
    await this.fetch();
    this.queryAction.shopify_created_at_max = this.lineItems[0].order.shopify_created_at;
    this.maxPage = Math.ceil(this.totalData / this.perPage);
    await this.getLineItemIds();
  }

  async request() {
    this.isLoading = true;
    try {
      const arr = _chunk(this.lineItemIds, 50);
      for (let i=0; i<arr.length; i++) {
        const fulfillment_request_res: any = await this.fulfillmentExtalnalRequestService.create({
          line_item_ids: arr[i]
        });
        this.successLineItemIds.push(
            ...fulfillment_request_res.fulfillment_external_request.line_item_ids
        );
      }
    } catch(e) {
      console.log(e)
    } finally {
      this.isLoading = false;
    }

    this.isDone = true;
  }

  async getLineItemIds() {
    this.isLoadingComponent = true;

    for (let i=1; i <= this.maxPage; i++) {
      this.currentPage = i;
      await this.fetch();
      this.lineItems.forEach((item: any) => {
        this.lineItemIds.push(item.line_item_id);
      })   
    }

    this.isLoadingComponent = false;
  }

  async fetch() {
    try {
      const res: any = await this.lineItemService.index({
        limit: this.perPage,
        offset: (this.currentPage - 1) * this.perPage,
        ...this.queryAction
      })
      this.totalData = res.total;
      this.lineItems = res.line_items;
    } catch(e) {
      console.log(e)
    }
  }
}
